import React from 'react';
import ProgressBar from 'ps-react/ProgressBar';

/** 70% progress */
export default function Example70Percent() {
  return <ProgressBar percent={70} width={150} />
}
